import { useEffect } from 'react'
import { useBackgroundTaskPoller } from '@/hooks/useBackgroundTaskPoller'
import { useBackgroundTaskStore, type BackgroundTask } from '@/stores/backgroundTaskStore'
import { announceBackgroundTaskStarted } from '@/lib/announceBackgroundTask'

export const BackgroundTaskManager = () => {
  useBackgroundTaskPoller()

  useEffect(() => {
    let prevTaskIds = new Set<string>()
    const unsub = useBackgroundTaskStore.subscribe((state) => {
      const currentIds = new Set(Object.keys(state.tasks))
      const newIds = [...currentIds].filter((id) => !prevTaskIds.has(id))

      for (const id of newIds) {
        const task: BackgroundTask = state.tasks[id]
        if (task.status === 'polling') {
          announceBackgroundTaskStarted(task.title, {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
          })
        }
      }

      prevTaskIds = currentIds
    })
    return unsub
  }, [])

  return null
}
